import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import MainLayout from './pages/Main.jsx';
import HomePage, { loader as vendorIconLoader } from './pages/Home.jsx';
import FilesPage, { action as filesAction, loader as filesLoader} from './pages/Files.jsx';
import AdvertisePage, { loader as advertiseLoader } from './pages/Advertise.jsx';
import { action as advertiseAction } from './components/Advertise.jsx';
import { ServicesSection, servicesLoader } from './pages/Services.jsx';
import AdvertiseServicesPage, { loader as advertiseServicesLoader } from './pages/AdvertiseServices.jsx';
import { action as editServiceAction } from './components/EditService.jsx';
import { VendorsPage, VendorVendorsPage, loader as vendorsLoader, vendorVendorsLoader } from './pages/Vendors.jsx';
import ErrorPage from './pages/Error.jsx';
import AuthenticationPage, { action as authAction } from './pages/Authentication.jsx';
import ChangePasswordPage, { action as changePasswordAction } from './pages/ChangePassword.jsx';
import CreateAccountPage, { action as createAccountAction } from './pages/CreateAccount.jsx';
import { action as logoutAction } from './pages/Logout';
import { tokenAuthLoader } from './util/auth.jsx'

const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    errorElement: <ErrorPage />,
    id: 'home',
    loader: tokenAuthLoader,
    children: [
      { index: true,
        element: <HomePage />,
        loader: vendorIconLoader,
      },
      {
        path: '/auth',
        element: <AuthenticationPage />,
        action: authAction,
      },
      {
        path: '/create-account',
        element: <CreateAccountPage />,
        action: createAccountAction,
      },
      {
        path: '/change-password',
        element: <ChangePasswordPage />,
        action: changePasswordAction,
      },
      {
        path: 'logout',
        action: logoutAction,
      },
      {
        path: '/files',
        element: <FilesPage />,
        action: filesAction,
        loader: filesLoader,
      },
      {
        path: '/advertise',
        element: <AdvertisePage />,
        action: advertiseAction,
        loader: advertiseLoader,
      },
      {
        path: '/advertiseServices',
        element: <AdvertiseServicesPage />,
        loader: advertiseServicesLoader,
        action: editServiceAction,
      },
      {
        path: '/vendors',
        children: [
          {
            index: true,
            element: <VendorsPage />,
            loader: vendorsLoader,
          },
          {
            path: ':vendorId',
            id: 'vendors-vendor',
            element: <VendorVendorsPage />,
            loader: vendorVendorsLoader,
          },
          {
            path: ':vendorId',
            id: 'services',
            element: <ServicesSection />,
            loader: servicesLoader,
          }
        ]
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
